import React from "react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./components/shared/protectedRoute";

import Adheridos from "./pages/adheridos";
import Recoleccion from "./pages/recoleccion";
import Reencauche from "./pages/reencauche";
import Emisiones from "./pages/emisiones";
import General from "./pages/general";
import Dashboard from "./pages/dashboard";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/admin/adheridos" element={<ProtectedRoute component={Adheridos} />} />
        <Route path="/admin/recoleccion" element={<ProtectedRoute component={Recoleccion} />} />
        <Route path="/admin/reencauche" element={<ProtectedRoute component={Reencauche} />} />
        <Route path="/admin/emisiones" element={<ProtectedRoute component={Emisiones} />} />
        <Route path="/admin/general" element={<ProtectedRoute component={General} />} />
        <Route path="/SEGINUS_HYUOP89_puntodegeneracion/graficas_panel_pdge0" element={<Dashboard />} />
        <Route
          path="/"
          element={
            <Navigate to={`/admin/general${window.location.search}`} replace />
          }
        />
      </Routes>
    </BrowserRouter>
  </StrictMode>
);